module.exports = __webpack_public_path__ + "img/btn_chatbot_pc.fd948121.png";